import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { CoachTrainingSessionDelete } from "./training-delete";
import { CoachTrainingSessionNew } from "./training-new";
import { CoachTrainingSessionEdit } from "./training-edit";
import { useNavigate } from "react-router-dom";
import { TrainingSessionPhase, TrainingSession } from "../../../../interfaces/training-session";
import { cloneTrainingSession, getTrainingSession } from "../../../../services/training-session";
import moment from 'moment';

export function CoachTrainingList() {
    const navigate = useNavigate();

    const [trainingSession, setTrainingSession] = useState<TrainingSession[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    useEffect(() => {
        getTrainingSession()
            .then((response: any) => {
                setTrainingSession(response.data);
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;

        /*getTrainingSession(s, club)
            .then(response => {
                setTrainingSession(response.data);
            })
            .catch(error => {
                console.log(error);
            });*/
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: TrainingSession) => {
        const newTrainingSession = [
            s,
            ...trainingSession
        ];
        setTrainingSession(newTrainingSession);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newTrainingSession = trainingSession.filter((m: TrainingSession) => m.id != id);
        setTrainingSession(newTrainingSession);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedTrainingSession: TrainingSession) => {
        setSelectedId(0);
        const newTrainingSession = trainingSession.map((m: TrainingSession) => {
            if (m.id == changedTrainingSession.id) {
                return changedTrainingSession;
            } else {
                return m;
            }
        });
        setTrainingSession(newTrainingSession);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handlePhases = (event: any) => {
        event.preventDefault();
        navigate('/coach/training-sessions/' + event.currentTarget.dataset.id +  '/phases')
    }

    const handleClone = (event: any) => {
        event.preventDefault();
        const body = {
            id: event.currentTarget.dataset.id
        }
        cloneTrainingSession(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    setTrainingSession([
                        response.data.data,
                        ...trainingSession
                    ]);
                } else {
                    alert(response.data.message);
                }
            });
    }

    return (
        <div className="training-sessions-list-container">
            <h1>
                { t('training_sessions')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { trainingSession.map((s: TrainingSession) => {
                        const numPhases = s.phases.length;
                        const numExercises = s.phases.reduce((previousValue, currentValue: TrainingSessionPhase) => {
                            return previousValue + currentValue.exercises.length
                         } , 0);
                        return <Col key={ 'training-session-' + s.id } xs={12} md={6} lg={4} xl={3}>
                            <div className="training-session-card">
                                <div className="inner">
                                    <div className="name">
                                        { s.name }
                                    </div>
                                    <div className="moment">
                                        { s.date_time == '0000-00-00 00:00:00' &&
                                            <span className="red"><i className="bi bi-calendar-week"></i> { t("no_date_planned") }</span>
                                        }
                                        { s.date_time != '0000-00-00 00:00:00' &&
                                            <span className="primary"><i className="bi bi-calendar-week"></i> { moment(s.date_time).format('DD/MM/YYYY H:m') }</span>
                                        }
                                    </div>
                                    <div className="meta">
                                        <div className="counter">
                                            { (numPhases == 0) && t("no_phases_message") } 
                                            { (numPhases == 1) && <span>{ t("one_phase") }</span> } 
                                            { (numPhases > 1) && <span>{ numPhases } { t("multiple_phases") }</span> }   
                                        </div>
                                        <div className="exercises">
                                            { (numExercises == 0) && t("no_exercises_message") } 
                                            { (numExercises == 1) && <span>{ t("one_exercise") }</span> } 
                                            { (numExercises > 1) && <span>{ numExercises } { t("multiple_exercises") }</span> }   
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="actions">
                                    <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ s.id }>
                                        <i className="bi bi-pencil-square"></i>
                                    </a>
                                    <a href="#" className="icon-link phases" title={ t("phases") } onClick={ handlePhases } data-id={ s.id }>
                                        <i className="bi bi-sliders2-vertical"></i>
                                    </a>
                                    <a href="#" className="icon-link clone" title={ t("clone") } onClick={ handleClone } data-id={ s.id }>
                                        <i className="bi bi-copy"></i>
                                    </a>
                                    <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ s.id }>
                                        <i className="bi bi-trash"></i>
                                    </a>
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
            </div>   
            {<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>}
            { showAddNew &&
                <CoachTrainingSessionNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <CoachTrainingSessionEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <CoachTrainingSessionDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
        </div>

    )
}
